import React, { type FC } from 'react';
import s from './accordion.module.scss';
import cn from 'classnames';
interface AccordionProps {
  isOpen: boolean;
  toggler: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}
export const Accordion: FC<AccordionProps> = ({
  isOpen,
  className,
  toggler,
  children
}) => {
  return <div className={cn(s.accordion, isOpen && s.accordion_open, className)} data-sentry-component="Accordion" data-sentry-source-file="Accordion.tsx">
            {toggler}
            <div className={s.accordion__box}>
                <ul className={s.accordion__body}>{children}</ul>
            </div>
        </div>;
};